import { Button } from '@tecma/ds/button';
import { useTranslation } from '@tecma/i18n';
import { useNavigate } from 'react-router-dom';

import { useStoreMobx } from 'mobx/helpers';

import './Navbar.Profile.scss';

export const NavbarProfile = () => {
  const store = useStoreMobx();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Button
      className='navbar-profile'
      onClick={() => {
        navigate(`/account-profile/${store.loggedUser?.id}`);
      }}
      color='transparent'
    >
      {t('iTd.navbar.profile')}
    </Button>
  );
};
